// constants

const CLEAR_DRAW_SET = "CLEAR_DRAW_SET";
const SET_DRAW_SET = "SET_DRAW_SET";

// reducers

const initialState = {};

const DrawSet = (state = initialState, action) => {
	switch (action.type) {
		case CLEAR_DRAW_SET:
			return {};

		case SET_DRAW_SET:
			return { ...action.payload };

		default:
			return state;
	}
};

export default DrawSet;

// actions

// const resolveAfter2Seconds = () => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve("resolved");
//     }, 2000);
//   });
// };

// export const testCounterDecrement = () => async (dispatch) => {
//   const result = await resolveAfter2Seconds();
//   console.log(result);
//   dispatch({
//     type: TEST_COUNTER_DECREMENT,
//   });
// };

export const clearDrawSet = () => {
	return {
		type: CLEAR_DRAW_SET,
	};
};

export const setDrawSet = (payload) => {
	return {
		type: SET_DRAW_SET,
		payload: payload,
	};
};
